<div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{title}}</h5>
      <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body scroll">
      <pre *ngIf="title != 'Read Me'">
<span>GRIT Version 1.0.0</span>

The <span>GNSS Interference Test (GRIT)</span> application is a specialized tool designed 
to support the planning, coordination, and execution of GNSS interference 
testing. Based on the EUROCONTROL Guidelines on a Process for Civil and 
Military GNSS Interference Testing, GRIT aims to harmonize procedures across 
EUROCONTROL Member States, ensuring a standardized and efficient approach 
to managing interference. By facilitating the sharing of best practices, GRIT helps 
minimize and mitigate the potential impact of GNSS interference on aviation 
safety.

GRIT addresses three primary scenarios for interference testing:

&#8226; <span>Within National Borders</span>
&#8226; <span>Cross-Border Scenarios</span>
&#8226; <span>Over High Seas</span>

The application provides a comprehensive solution that incorporates the roles 
of various stakeholders—including civil, military and national security authorities, 
Air Navigation Service Providers (ANSPs), national radio regulators, and 
airspace users—ensuring that each phase of GNSS interference testing is 
properly assessed, coordinated, and notified.

<span>Key functionalities</span>

GRIT helps ensure safety of operations by enabling:

&#8226; Design of GNSS jamming and spoofing events
&#8226; Conduct impact assessments on aviation operations based on airspace areas 
   and infrastructure in place
&#8226; Workflow with roles and responsibilities for interference testing 
   decision-making process
&#8226; Cross-border coordination
&#8226; Generation of publication proposals (NOTAM and/or AIP SUP)
&#8226; Implementation of the EUROCONTROL Guidelines on coordinating Civil and 
   Military GNSS Interference Testing

<span>Key Features</span>

&#8226; <span>Receiver, Jammer and Spoofer Management:</span> Efficiently define, 
   organize and manage data for a variety of jamming and spoofing devices to 
   ensure best practices in designing GNSS jamming or spoofing testing activities.
&#8226; <span>Coverage areas:</span> Calculate, visualise, and organise interference areas 
    resulting from the design of the GNSS jamming or spoofing activity.
&#8226; <span>Interference Test Management:</span> Manage the complete lifecycle of GNSS 
   interference tests, from initial planning to final execution, with tools for 
   scheduling, monitoring, and documentation.
&#8226; <span>Impact Assessment:</span> Visualise airport location, navigation and 
    surveillance infrastructure, as well as airspace areas, to evaluate the 
    operational impact of interference tests, supporting effective risk 
    assessment and mitigation strategies.
&#8226; <span>Coordination and Approval Workflow:</span> Simplify the coordination 
    and approval process through structured workflows, ensuring all tests are 
    validated and approved by relevant authorities.
&#8226; <span>NOTAM proposal:</span> Automated NOTAM proposal to the interested 
    entities based on the characteristics of the GNSS testing exercise.
&#8226; <span>Import and Export Capabilities:</span> Seamlessly handle multiple data 
    formats, including JSON, XML, ARINC, AIXM 4.5, and AIXM 5.1, for 
    robust data integration and exchange.

<span>Additional Tools</span>

&#8226; <span>Mailing List Management:</span> Create and maintain communication lists 
    for targeted notifications during testing phases.
&#8226; <span>FIR Subscriptions:</span> Receive notifications about relevant events and 
    activities occurring within subscribed Flight Information Regions, ensuring 
    you stay informed of any critical changes in the airspace.
&#8226; <span>NavAid Coverage Calculation:</span> Evaluate the coverage areas for 
    navaids signals, assisting in detailed interference planning and 
    impact assessment.
&#8226; <span>Surveillance and airspace data:</span> Visualise and organise radar and 
    airspace data for assisting in impact assessment.
&#8226; <span>Mapping Enhancements:</span> Utilize advanced mapping tools like Altitude 
    Filtering, Cross Section Analysis, Map Search, and Terrain Height Analysis 
    for comprehensive map-based assessments.

To learn more about how to leverage GRIT’s capabilities, refer to the User 
Manual available within the application for detailed guidance and best practices.
      </pre>

      <pre *ngIf="title == 'Read Me'">
<span>GRIT Version 1.0.0</span>

This is the first release of our system designed to support the planning of the 
<span>GNSS Interference Tests</span>. Below is a summary of the core features included 
in this version.

<span>Core Features</span>

&#8226; <span>Management of Receivers and Jammer and Spoofers:</span> Easily organize 
   and manage data for all receivers, jammers and spoofers devices.
&#8226; <span>Design and Impact Assessment:</span> Calculate the operational impacted area 
   of the interference test and assess impact on operations.
&#8226; <span>Interference Test Management:</span> Manage the complete lifecycle of GNSS 
   interference tests, from initial planning to final execution.
&#8226; <span>Coordination and Approval Workflow:</span> Streamlined workflow for 
   approving and validating GNSS interference tests.
&#8226; <span>NOTAM proposal:</span> Automated NOTAM proposal to the interested entities.
&#8226; <span>Import and Export:</span> Import and export entities (Transmitters, Receivers, 
   Navaids, radar, and airspace areas …) in multiple formats including JSON, XML, 
   ARINC, AIXM 4.5, and AIXM 5.1.

<span>Additional Features</span>

&#8226; <span>Mailing List Management:</span> Create and manage communication lists for 
   notifications.
&#8226; <span>FIR Subscriptions:</span> Subscribe to and manage Flight Information Regions.
&#8226; <span>Navaids, Surveillance and Coordinate Points:</span> Manage Navaids, 
   surveillance and coordinate points for accurate data analysis.
&#8226; <span>Coverage Calculation:</span> Calculate coverage areas for Navaids to assess signal 
reach.
&#8226; <span>Mapping Tools:</span> Additional tools like Altitude Filtering, Cross Section Analysis, 
   Map Search, and Terrain Height Analysis for detailed map assessments.
  
For detailed information, please refer to the User Manual available within the 
application. 
      </pre>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-primary"
        data-dismiss="modal"
        (click)="onClose()"
      >
        Ok
      </button>
    </div>
</div>
